<div class="doc-preview-card" *ngIf="src">

  <!-- Image Preview -->
  <div class="preview-area" *ngIf="fileType === 'IMAGE'">
    <a [href]="src" target="_blank" class="img-link">
      <img [src]="src" [alt]="fileName" class="preview-img" />
      <div class="img-overlay">
        <i class="pi pi-external-link"></i>
      </div>
    </a>
  </div>

  <!-- Non-image Preview -->
  <div class="preview-area doc-area" *ngIf="fileType !== 'IMAGE'">
    <a [href]="src" target="_blank" class="doc-link">
      <i [class]="getDocIcon()" [style.color]="getDocColor()" class="doc-icon"></i>
      <span class="doc-ext">{{ src.split('.').pop()?.toUpperCase() }}</span>
      <div class="img-overlay">
        <i class="pi pi-download"></i>
      </div>
    </a>
  </div>

  <!-- Footer -->
  <div class="preview-footer">
    <span class="file-name" [title]="remarks || fileName">
      {{ remarks || fileName }}
    </span>
    <button
      *ngIf="showDelete"
      type="button"
      class="delete-btn"
      (click)="delete()"
      title="Remove file"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>
